import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type PaygDetail = {
  id: number;
  ts: string;
  amount_charged: number;
  expiry_on: string | null;
  license_type?: string;
  status_id?: number;
  status_code?: string;
  total_credits: number;
  topup_amount: number;
  billing_cycle: string | null;
  expires_on: string | null;
  in_plan_consumed_credits: number | null;
  in_plan_total_credits: number | null;
  consumed_credits: number | null;
  workflow_credits?: number;
};

type PaygState = {
  currency: string;
  isPaygActive: boolean;
  paygDetail: PaygDetail | null;
  hasPaymentFailure: boolean;
};

export const initialState: PaygState = {
  currency: '€',
  isPaygActive: false,
  paygDetail: null,
  hasPaymentFailure: false
};

const slice = createSlice({
  name: 'payg',
  initialState,
  reducers: {
    setCurrency(state, action: PayloadAction<string>) {
      state.currency = action.payload;
    },
    setIsPaygActive(state, action: PayloadAction<boolean>) {
      state.isPaygActive = action.payload;
    },
    setPaygDetail(state, action: PayloadAction<PaygDetail | null>) {
      state.paygDetail = action.payload;
    },
    setPaymentFailure(state, action: PayloadAction<boolean>) {
      state.hasPaymentFailure = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const {
  setCurrency,
  setIsPaygActive,
  setPaygDetail,
  setPaymentFailure
} = slice.actions;

export const selectIsPaygLicenseActive = (state: {
  payg: PaygState;
}): boolean => state.payg.isPaygActive;

export default slice;
